import { render, staticRenderFns } from "./AlertGridDetails.vue?vue&type=template&id=c10befd6&"
import script from "./AlertGridDetails.vue?vue&type=script&lang=js&"
export * from "./AlertGridDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports